/**
 * Lý do không đạt tiêu chí
 */
export default {
  None: 0,
  NotArea: 1, // do không thuộc khu vực tuyển sinh
  NotYearBorn: 2, // do không thuộc độ tuổi tuyển sinh
  All: 3, // cả 2
}
